import { Component, Switch, Match } from "solid-js";
import { useCheckoutFlowNavigation } from "@/hooks/checkoutFlowNavigation";

export type CheckoutAlertType = "soldout" | "maxscheduled";

interface CheckoutAlertProps {
  type: CheckoutAlertType;
}

const MaxScheduledAlert: Component = () => {
  const { exitFeaturedDealer } = useCheckoutFlowNavigation();

  return (
    <fd-mfe-alert
      prop:variant="warning"
      prop:leadingIcon={true}
      class="pb-FsSpacing3x"
      data-testid="max-scheduled-alert"
    >
      You have already scheduled the maximum amount of campaigns. Visit campaign
      details to cancel.
      <fd-mfe-button
        onClick={exitFeaturedDealer}
        prop:variant="neutral"
        prop:slot="alert-button"
        prop:size="small"
        data-testid="see-campaigns-button"
      >
        See campaigns
      </fd-mfe-button>
    </fd-mfe-alert>
  );
};

const SoldOutAlert: Component = () => {
  return (
    <fd-mfe-alert
      prop:variant="warning"
      prop:leadingIcon={true}
      class="pb-FsSpacing3x"
    >
      All time slots have been sold out.
    </fd-mfe-alert>
  );
};

export const CheckoutAlert: Component<CheckoutAlertProps> = (props) => {
  return (
    <Switch>
      <Match when={props.type === "maxscheduled"}>
        <MaxScheduledAlert />
      </Match>
      <Match when={props.type === "soldout"}>
        <SoldOutAlert />
      </Match>
    </Switch>
  );
};
